import { Shape, AbstractCanvas2D } from '@maxgraph/core';

/**
 * Hexagon shape for material nodes.
 *
 * The hexagon is drawn with a flat top/bottom (pointy sides) orientation,
 * matching the domain vocabulary in the SDD:
 *   top-center → right-top → right-bottom → bottom-center →
 *   left-bottom → left-top → close
 *
 * Fill/stroke colors come from the cell style applied by downstream code.
 */
export class MaterialHexagonShape extends Shape {
  paintBackground(
    c: AbstractCanvas2D,
    x: number,
    y: number,
    w: number,
    h: number
  ): void {
    c.begin();
    c.moveTo(x + w / 2, y);
    c.lineTo(x + w, y + h / 4);
    c.lineTo(x + w, y + (3 * h) / 4);
    c.lineTo(x + w / 2, y + h);
    c.lineTo(x, y + (3 * h) / 4);
    c.lineTo(x, y + h / 4);
    c.close();
    c.fillAndStroke();
  }
}
